'use strict';

var _get = require('babel-runtime/helpers/get')['default'];

var _inherits = require('babel-runtime/helpers/inherits')['default'];

var _createClass = require('babel-runtime/helpers/create-class')['default'];

var _classCallCheck = require('babel-runtime/helpers/class-call-check')['default'];

var _Promise = require('babel-runtime/core-js/promise')['default'];

Object.defineProperty(exports, '__esModule', {
    value: true
});
exports['default'] = makeSingle;

var _errors = require('./errors');

function makeSingle(baseClass) {
    var SingleObjectResource = (function (_baseClass) {
        _inherits(SingleObjectResource, _baseClass);

        _createClass(SingleObjectResource, null, [{
            key: 'STATUS_CODE',
            value: [200, 201],
            enumerable: true
        }]);

        function SingleObjectResource(apiEndpoint, expectedStatus, mutateResponse) {
            _classCallCheck(this, SingleObjectResource);

            if (!expectedStatus) {
                expectedStatus = SingleObjectResource.STATUS_CODE;
            }

            _get(Object.getPrototypeOf(SingleObjectResource.prototype), 'constructor', this).call(this, apiEndpoint, expectedStatus, mutateResponse);
        }

        // TODO: Add delete, head

        _createClass(SingleObjectResource, [{
            key: 'fetch',
            value: function fetch(kwargs, query) {
                var thePath = this.buildThePath(kwargs);

                return this.handleRequest(this.createRequest('get', thePath, query)).then(function (response) {
                    return response;
                })['catch'](function (err) {
                    throw err;
                });
            }
        }, {
            key: 'post',
            value: function post(kwargs, data, query) {
                var method = arguments.length <= 3 || arguments[3] === undefined ? 'post' : arguments[3];

                var thePath = this.buildThePath(kwargs);

                return this.handleRequest(this.createRequest(method, thePath, query, data || {})).then(function (response) {
                    return response;
                })['catch'](function (err) {
                    if (err instanceof _errors.InvalidResponseCode) {
                        if (err.statusCode === 400) {
                            throw new _errors.ValidationError(err);
                        }
                    }

                    throw err;
                });
            }
        }, {
            key: 'patch',
            value: function patch(kwargs, data, query) {
                return this.post(kwargs, data, query, 'patch');
            }
        }, {
            key: 'put',
            value: function put(kwargs, data, query) {
                return this.post(kwargs, data, query, 'put');
            }
        }, {
            key: 'del',
            value: function del(kwargs, data, query) {
                return this.post(kwargs, data, query, 'del');
            }
        }, {
            key: 'sourcePost',
            value: function sourcePost(kwargs, data, query, uuid, errCb) {
                var _this = this;

                return new _Promise(function (resolve, reject) {
                    _this.post(kwargs, data, query).then(function (response) {
                        if (uuid) {
                            resolve({ data: response, uuid: uuid });
                        } else {
                            resolve(response);
                        }
                    })['catch'](function (error) {
                        // If we get something other than 400, lets trigger errCb|this.onSourceError
                        if (error.statusCode !== 400) {
                            (errCb || _this.onSourceError)(error);
                        }

                        // Also reject
                        reject({ error: error, postData: postData });
                    });
                });
            }
        }]);

        return SingleObjectResource;
    })(baseClass);

    return SingleObjectResource;
}

module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./~/tg-resources/dist/single.js
 ** module id = 1053
 ** module chunks = 1
 **/